import React from 'react';
import { Box, VStack, Flex, Text } from '@chakra-ui/react';
import { FiMapPin } from 'react-icons/fi';
import { stepTitleProps, wizardTokens } from '../styles';

interface SingleLocationConfirmProps {
  name: string;
  fullAddress: string;
}

// Dedicated view when a collab has exactly one location: nothing to pick, just confirm the venue.
// Styled as the board's selected location row (BookVisit step 2).
const SingleLocationConfirm: React.FC<SingleLocationConfirmProps> = ({ name, fullAddress }) => (
  <VStack spacing="16px" align="stretch" w="100%" fontFamily="display">
    <VStack spacing="8px" align="stretch">
      <Text {...stepTitleProps}>Here's your location</Text>
      <Text m={0} fontSize="15px" lineHeight="1.4" color="#55555A">
        This collaboration is for one location. Confirm below to continue.
      </Text>
    </VStack>

    <Flex
      minH="80px"
      p="14px"
      borderRadius="16px"
      align="flex-start"
      gap="12px"
      border={`2px solid ${wizardTokens.ink}`}
      bg="#F1FADF"
      color={wizardTokens.ink}
    >
      <Box as="span" flex="none" w="22px" h="22px" boxSizing="border-box" borderRadius="999px" border={`7px solid ${wizardTokens.ink}`} bg="#FFFFFF" />
      <Flex flex={1} minW={0} direction="column" gap="3px">
        <Text fontSize="16px" fontWeight={600} lineHeight="normal" noOfLines={1}>{name || fullAddress}</Text>
        <Text fontSize="13px" lineHeight="1.35" color="#55555A" noOfLines={2}>{fullAddress}</Text>
      </Flex>
    </Flex>

    <Flex p="12px 14px" borderRadius="14px" bg="#F2F2F0" gap="10px" align="flex-start" fontSize="14px" lineHeight="1.4" color="#3E3E42">
      <Box as="span" flex="none" mt="1px" aria-hidden><FiMapPin size={18} strokeWidth={2.2} /></Box>
      <Text as="span">
        <Text as="strong" color={wizardTokens.ink}>One location collaboration.</Text> This brand only has one location. You'll visit the spot shown above.
      </Text>
    </Flex>
  </VStack>
);

export default SingleLocationConfirm;
